import React, { useEffect, useState } from 'react';
import { Card, CardContent, Typography, Box } from '@mui/material';
import axios from 'axios';

const GlobalQuotaComponent = ({ setGlobalQuotaForOtherComponents }) => {
    const [globalQuota, setGlobalQuota] = useState(0);
    const [unavailable, setUnavailable] = useState(false);

    useEffect(() => {
        const fetchTotalUsers = async () => {
            try {
                const response = await axios.get('/api/users/count');
                const totalUsers = (response && response.data && response.data.totalUsers) || 0;

                // Group users in 35s before applying the 4-session multiplier.
                const userGroups = Math.ceil(totalUsers / 35);
                const calculatedQuota = userGroups * 4;

                setGlobalQuota(calculatedQuota);
                setUnavailable(false);

                // Guard the callback: a missing or invalid prop must not throw
                // ("t is not a function") out of this handler.
                if (typeof setGlobalQuotaForOtherComponents === 'function') {
                    setGlobalQuotaForOtherComponents(calculatedQuota);
                }
            } catch (error) {
                // Failed or blocked fetch: render a quiet fallback, never throw.
                console.error('Error fetching total users:', error);
                setUnavailable(true);
            }
        };

        fetchTotalUsers();
    }, []);

    return (
        <Card
            sx={{
                backgroundColor: '#202020',
                color: '#fff',
                padding: '2rem',
                borderRadius: '12px',
                minHeight: '180px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            }}
        >
            <CardContent sx={{ textAlign: 'center' }}>
                <Typography variant="h5" sx={{ marginBottom: '1rem', fontWeight: '500' }}>
                    Monthly Session Quota (Global)
                </Typography>
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        minHeight: '80px',
                    }}
                >
                    {unavailable ? (
                        <Typography variant="h5" sx={{ color: '#888', fontWeight: '500' }}>
                            Unavailable
                        </Typography>
                    ) : (
                        <Typography variant="h3" sx={{ color: '#12c099', fontWeight: 'bold' }}>
                            {globalQuota}
                        </Typography>
                    )}
                </Box>
                <Typography variant="body2">
                    {unavailable ? 'Could not load user signups' : 'Based on user signups'}
                </Typography>
            </CardContent>
        </Card>
    );
};

export default GlobalQuotaComponent;
